import { fieldSchema } from '../../../shared/constants'

export default {
  default: {},
  validator() {},
  fieldSchema,
}
